<template lang="pug">
article-list-page-template.px-lg-15(
  :title="pageTitle",
  :loading="loading",
  :page="page",
  :pagesLength="pagesLength",
  :pages-total-visible="pagesTotalVisible",
  no-data-text="Nenhuma notícia disponível."
)
  template(#items)
    article-card.mx-auto(
      v-for="({ title, scheduled, text, img, to }, i) in items",
      :key="i",
      :title="title",
      :date="scheduled",
      :text="text",
      :img="img",
      :to="to"
    )
  template(#side)
    communications-widget
</template>

<script>
import ArticleListPageTemplate from "@/components/templates/ArticleListPage.vue";
import ArticleCard from "@/components/cards/Article";
import CommunicationsWidget from "@/components/widgets/Communications";
import { formatToURL } from "@/components/utils.js";

const _config = {
  mod: "articles",
  title: "Notícias",
  path: "/novidades/noticias",
  itemsPerPage: 12,
};

export default {
  data: () => ({
    pageTitle: _config.title,
    loading: true,
    totalItems: 0,
  }),
  computed: {
    pagesTotalVisible() {
      return this.$vuetify.breakpoint.smAndDown ? 3 : 6;
    },
    page() {
      const p = this.$route.query.p;
      return p ? parseInt(p) : 1;
    },
    pagesLength() {
      return Math.ceil(this.totalItems / _config.itemsPerPage);
    },
    items() {
      return this.$rest(_config.mod).list.map(
        ({ id, title, scheduled, img, text }) => ({
          title,
          img: this.files + img,
          scheduled,
          text,
          to: `${_config.path}/${formatToURL(title)}-${id}`,
        })
      );
    },
  },
  methods: {
    getItems() {
      this.loading = true;

      const params = {
        returnTotalItems: 1,
        itemsPerPage: _config.itemsPerPage,
      };
      if (this.page) params.page = this.page;

      this.$rest(_config.mod).get({
        params,
        keepCache: true,
        save: (state, { totalItems, list }) => {
          this.totalItems = totalItems;
          state.list = list;
          this.loading = false;
        },
      });
    },
  },
  watch: {
    page() {
      this.getItems();
    },
  },
  created() {
    this.getItems();
  },
  components: {
    ArticleListPageTemplate,
    ArticleCard,
    CommunicationsWidget,
  },
};
</script>
